import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mfa-new-device2',
  templateUrl: './mfa-new-device2.component.html',
  styleUrls: ['./mfa-new-device2.component.scss']
})
export class MfaNewDevice2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
